import React from 'react';

import {AnnotationHighlightModel} from '../../../models/api/annotationModel';

/*
 * Build a 2-line preview for the annotation that tries to fit on 1-2 lines:
 * - If the annotation is short, include more surrounding text.
 * - Reduce surrounding text if annotation is longer.
 * - Only include beginning/end of annotated text if annotation is very long.
 */
export function renderAnnotationPreview(annotation: AnnotationHighlightModel) {
  const {text, textBefore, textAfter} = annotation;

  return (
    <>
      {textBefore}
      <mark>{text}</mark>
      {textAfter}
    </>
  );
}
